import { useIntl } from "react-intl";
import {
  Icon,
  Column,
  ReadyToStart,
  Layout,
  Console,
  List,
  ItemList,
} from "../../components";
// import { paymentLink, quickTransfer } from "../../services/animationIcons";
import quickTransfer from "../../assets/icons/QuickTransfer_new.svg";
import paymentLink from "../../assets/icons/PaymentLinks_new.svg";
import python from "../../assets/icons/Python.svg";
import sdk from "../../assets/icons/SDK.svg";
import nodejs from "../../assets/icons/NodeJS.svg";
import net from "../../assets/icons/net.svg";
import maven from "../../assets/icons/Maven(Java).svg";
import php from "../../assets/icons/PHP.svg";
// import { paymentLink } from
import "./Developers.scss";
import ReactGA from "react-ga4";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { useEffect } from "react";
import useAppContext from "../../context/Context";
import Cms from "../../components/Cms/Cms";

import logoDD from "../../assets/icons/SuscriptionPayments.svg";
import logoBT from "../../assets/images/business-transfer/BusinessTransferLogo.svg";

import backgroundVectorMobile from "../../assets/images/Animatic.svg";
import backgroundVectorMobile2 from "../../assets/images/Animatic2.svg";

gsap.registerPlugin(ScrollTrigger);

const ecom = [
  {
    icon: "CheckCircleBlack",
    name: "Magento",
    new: false,
  },
  {
    icon: "CheckCircleBlack",
    name: "Prestashop",
    new: false,
  },
  {
    icon: "CheckCircleBlack",
    name: "Vtex",
    new: false,
  },
  {
    icon: "CheckCircleBlack",
    name: "WooComerce",
    new: false,
  },
];

export const Developers = () => {
  ReactGA.send({ hitType: "pageview", page: "/developers" });
  const { activeCountry } = useAppContext();

  useEffect(() => {
    const tlData = gsap
      .timeline({
        scrollTrigger: {
          trigger: ".section2",
          start: "top 150px",
          end: "65% 40%",
          scrub: 1,
          pin: ".animation",
        },
      })
      .to(".web-back", {
        clipPath: "polygon(54% 13%, 84% 35%, 73% 69%, 22% 47%)",
      })
      .to(".web-back-circle", {
        transform: "translate(-110px, -110px) scale(1)",
      })
      .to(".dot-2", {
        transform: "translate(-5px,-132px) scale(0.5)",
      })
      .to(".dot-3", {
        transform: "translate(115px,-41px) scale(0.5)",
      })
      .to(".dot-4", {
        transform: "translate(71px,92px) scale(0.5)",
      })
      .to(".dot-5", {
        transform: "translate(-132px,5px) scale(0.5)",
      })
      .to(".line-1", {
        transform: "translate(20px,20px) rotate(-19deg)",
        width: "0px",
      })
      .to(".line-2", {
        transform: "translate(20px,20px) rotate(-92deg)",
        width: "0px",
      })
      .to(".line-3", {
        transform: "translate(20px,20px) rotate(-182deg)",
        width: "0px",
      })
      .to(".line-4", {
        transform: "translate(20px,20px) rotate(70deg)",
        width: "0px",
      });
    return () => {
      tlData.kill();
      // anim.scrollTrigger.kill();
    };
  }, []);
  return (
    <Layout title="Desarrollo">
      <div className="developers-page">
        <Column customClass="banner-developers">
          <img className="img-figure" src="Mesh-Grad2.svg" alt="" />
          <img className="img-texture" src="Grain-Texture2.svg" alt="" />
          <h1 className="title">
            {useIntl().formatMessage({ id: "developers.banner.title" })}
          </h1>
          <h2 className="description">
            {useIntl().formatMessage({ id: "developers.banner.description" })}
          </h2>

          <a
            className="link"
            href={useIntl().formatMessage({ id: "goToDocumentation.link" })}
            target="_blank"
            rel="noreferrer"
          >
            {useIntl().formatMessage({ id: "goToDocumentation.text" })}{" "}
            <Icon name="Icon_After" color="#140F33" />
          </a>
        </Column>
        <Column customClass="section1">
          <Console className="console"></Console>
          <h4 className="performance">
            {useIntl().formatMessage({
              id: "developers.section1.performance",
            })}
          </h4>
          <h2 className="title">
            {useIntl().formatMessage({ id: "developers.section1.title" })}
          </h2>
          <h3 className="description">
            {useIntl().formatMessage({
              id: "developers.section1.description",
            })}
          </h3>
          <div className="divImgMobile">
            <img src={backgroundVectorMobile} className="imgMobile" />
          </div>
        </Column>
        <Column customClass="section2">
          <div className="img-figure">
            <img src="Mesh-Grad3.svg" alt="" />
          </div>
          <div className="list marginTop-integration">
            <div className="part">
              <h3 className="top-title">
                {useIntl().formatMessage({ id: "developers.section2.t1" })}
              </h3>
              <h4 className="sub-title">
                {useIntl().formatMessage({ id: "developers.section2.t2" })}
              </h4>
              <List customClass="bank-list">
                {ecom.map((e, index) => (
                  <ItemList key={index}>
                    <Icon name={e.icon} size="24px" />
                    <p className="name">{e.name}</p>
                    {e.new && <label className="new">Proximamente</label>}
                  </ItemList>
                ))}
              </List>
            </div>
            <div className="part marginBottom-api">
              <h3 className="top-title">
                {useIntl().formatMessage({ id: "developers.section2.t3" })}
              </h3>
              <h4 className="sub-title">
                {useIntl().formatMessage({ id: "developers.section2.t4" })}
              </h4>
            </div>
          </div>

          {/* desktop */}
          <div className="animation">
            <div className="web">
              <div className="web-line line-1"></div>
              <div className="web-line line-2"></div>
              <div className="web-line line-3"></div>
              <div className="web-line line-4"></div>

              <div className="web-back"></div>
              <div className="web-back-circle"></div>

              <div className="web-dot dot-1"></div>
              <div className="web-dot dot-2"></div>
              <div className="web-dot dot-3"></div>
              <div className="web-dot dot-4"></div>
              <div className="web-dot dot-5"></div>
            </div>
          </div>

          <div className="divImgMobile">
            <img src={backgroundVectorMobile2} className="imgMobile" alt="" />
          </div>
        </Column>
        <Column customClass="section3-developer">
          <h4 className="top-title">
            {useIntl().formatMessage({ id: "developers.section3.topTitle" })}
          </h4>
          <h2 className="title">
            {useIntl().formatMessage({ id: "developers.section3.title" })}
          </h2>
          <h3 className="description">
            {useIntl().formatMessage({
              id: "developers.section3.description",
            })}
          </h3>
          {/* <div> */}
          <div className="item first">
            <div className="icon">
              <img src={quickTransfer} alt="" />
              {/* <AnimateIcon json={QuickTransfer} size="3.5rem" /> */}
            </div>
            <div className="content">
              <h3 className="title">
                {useIntl().formatMessage({
                  id: "developers.section3.item1.title",
                })}
              </h3>
              <h5 className="description">
                {useIntl().formatMessage({
                  id: "developers.section3.item1.description",
                })}
              </h5>
              <a
                target={"_blank"}
                className="link"
                href={
                  activeCountry === "cl"
                    ? "https://etpay.notion.site/Quick-Transfer-ed001e382e904a9ba6551fe3c0831ed9"
                    : "https://etpay.notion.site/Quick-Transfer-c6cc0d6b954347dcaed6844c8b176cfe"
                }
                rel="noreferrer"
              >
                {useIntl().formatMessage({
                  id: "goToDocumentation.text",
                })}
                <Icon name="Icon_After" color="white" />
              </a>
            </div>
          </div>
          {activeCountry === "cl" && (
            <>
              <div className="item second">
                <div className="icon">
                  <img src={paymentLink} alt="" />
                  {/* <AnimateIcon json={paymentLink} size="3.5rem" /> */}
                </div>
                <div className="content">
                  <h3 className="title">Payment Links</h3>
                  <h5 className="description">
                    Pagos por Internet sin tarjeta
                  </h5>
                  <a
                    className="link"
                    href="https://support.etpay.com/support/solutions/articles/67000707392-documentaci%C3%B3n-t%C3%A9cnica-cl"
                  >
                    Ir a la documentación
                    <Icon name="Icon_After" color="white" />
                  </a>
                </div>
              </div>
              <div className="item first-row-5">
                <div className="icon">
                  <img src={logoDD} alt="" />
                  {/* <AnimateIcon json={QuickTransfer} size="3.5rem" /> */}
                </div>
                <div className="content">
                  <h3 className="title">Débito Directo</h3>
                  <h5 className="description">Recibe pagos recurrentes</h5>
                  <a
                    target={"_blank"}
                    className="link"
                    href={
                      "https://etpay.notion.site/D-bito-Directo-9f526fb74a6440fcb66ee05fd41bafee"
                    }
                    rel="noreferrer"
                  >
                    Ir a la documentación
                    <Icon name="Icon_After" color="white" />
                  </a>
                </div>
              </div>
              <div className="item second-row-5">
                <div className="icon">
                  <img src={logoBT} alt="" />
                  {/* <AnimateIcon json={QuickTransfer} size="3.5rem" /> */}
                </div>
                <div className="content">
                  <h3 className="title">Business Transfer</h3>
                  <h5 className="description">Pagos de empresa</h5>
                  <a
                    target={"_blank"}
                    className="link"
                    href={
                      "https://etpay.notion.site/Business-Transfer-da34b33fbb1842c1b88035e1aa69c360"
                    }
                    rel="noreferrer"
                  >
                    Ir a la documentación
                    <Icon name="Icon_After" color="white" />
                  </a>
                </div>
              </div>
            </>
          )}
        </Column>

        <Column
          className={
            activeCountry === "cl"
              ? "sectionSDK"
              : "sectionSDK sectionSDKNoDisplay"
          }
        >
          <h4 className="top-title">
            {useIntl().formatMessage({
              id: "developers.sectionSdk.topTitle",
            })}
          </h4>
          <h2 className="title">
            {useIntl().formatMessage({ id: "developers.sectionSdk.title" })}
          </h2>
          <h3 className="description">
            {useIntl().formatMessage({
              id: "developers.sectionSdk.description",
            })}
          </h3>
          <div className="item first">
            <div className="icon">
              <img src={python} alt="" />
            </div>
            <div className="content">
              <h3 className="title">
                {useIntl().formatMessage({
                  id: "developers.sectionSdk.item1.title",
                })}
              </h3>

              <a
                target={"_blank"}
                className="link"
                href="https://pypi.org/project/etpay-sdk/"
                rel="noreferrer"
              >
                {useIntl().formatMessage({
                  id: "developers.sectionSdk.item1.description",
                })}
                <Icon name="Icon_After" color="white" />
              </a>
            </div>
          </div>
          <div className="item second">
            <div className="icon">
              <img src={nodejs} alt="" />
            </div>
            <div className="content">
              <h3 className="title">
                {useIntl().formatMessage({
                  id: "developers.sectionSdk.item2.title",
                })}
              </h3>

              <a
                target={"_blank"}
                className="link"
                href="https://www.npmjs.com/package/etpay-sdk"
                rel="noreferrer"
              >
                {useIntl().formatMessage({
                  id: "developers.sectionSdk.item1.description",
                })}
                <Icon name="Icon_After" color="white" />
              </a>
            </div>
          </div>
          <div className="item third">
            <div className="icon">
              <img src={net} alt="" />
            </div>
            <div className="content">
              <h3 className="title">
                {useIntl().formatMessage({
                  id: "developers.sectionSdk.item3.title",
                })}
              </h3>
              <a
                target={"_blank"}
                className="link"
                href="https://www.nuget.org/packages/etpay-dotnet-sdk/"
                rel="noreferrer"
              >
                {useIntl().formatMessage({
                  id: "developers.sectionSdk.item3.description",
                })}
                <Icon name="Icon_After" color="white" />
              </a>
            </div>
          </div>
          <div className="item fourth">
            <div className="icon">
              <img src={maven} alt="" />
            </div>
            <div className="content">
              <h3 className="title">
                {useIntl().formatMessage({
                  id: "developers.sectionSdk.item4.title",
                })}
              </h3>

              <a
                target={"_blank"}
                className="link"
                href="https://gitlab.com/etpayment/etpay-sdk-maven"
                rel="noreferrer"
              >
                {useIntl().formatMessage({
                  id: "developers.sectionSdk.item4.description",
                })}
                <Icon name="Icon_After" color="white" />
              </a>
            </div>
          </div>
          <div className="item fifth">
            <div className="icon">
              <img src={php} alt="" />
            </div>
            <div className="content">
              <h3 className="title">
                {useIntl().formatMessage({
                  id: "developers.sectionSdk.item5.title",
                })}
              </h3>
              <a
                target={"_blank"}
                className="link"
                href="https://packagist.org/packages/etpay/php-sdk"
                rel="noreferrer"
              >
                {useIntl().formatMessage({
                  id: "developers.sectionSdk.item5.description",
                })}
                <Icon name="Icon_After" color="white" />
              </a>
            </div>
          </div>
          <div className="item sixth">
            <div className="icon">
              <img src={sdk} alt="" />
            </div>
            <div className="content">
              <h3 className="title">
                {useIntl().formatMessage({
                  id: "developers.sectionSdk.item6.title",
                })}
              </h3>

              <a
                target={"_blank"}
                className="link"
                href="https://etpay.notion.site/I-Preparaci-n-del-ambiente-0a86bcad09b040939cf1819553a2f43a"
                rel="noreferrer"
              >
                {useIntl().formatMessage({
                  id: "developers.sectionSdk.item6.description",
                })}
                <Icon name="Icon_After" color="white" />
              </a>
            </div>
          </div>
        </Column>

        <Cms></Cms>
        <ReadyToStart
          bgColor={activeCountry === "cl" ? "#262255" : "#141033"}
          color="white"
        ></ReadyToStart>
      </div>
    </Layout>
  );
};
